import { Injectable } from '@angular/core';
import { AvatarImageService } from '../avatar-image.service';
import { HelperManagerAdminService } from '../helper-manager-admin.service';
import { KeyValAdminService } from '../key-val-admin.service';

@Injectable({
  providedIn: 'root'
})
export class ChatAvatarManagerService {

  constructor(
    private keyvalManager: KeyValAdminService,
    private helperManager: HelperManagerAdminService,
    private avatarImage: AvatarImageService
  ) { }

  public async setBotImg(skillId: string) {
    let url = "";
    if (skillId.startsWith('http')) {
      url = skillId; // If the skillId is already a URL, use it directly
    } else {
      url = this.helperManager.getImageURlFromSkill(skillId);
    }
    await this.keyvalManager.set('botAvatar', url, 'avatarImage');
    await this.avatarImage.loadBotAvatarUrl();
  }

  public async setUserImg(skillId: string) {
    let url = "";
    if (skillId.startsWith('http')) {
      url = skillId; // If the skillId is already a URL, use it directly
    } else {
      url = this.helperManager.getImageURlFromSkill(skillId);
    }
    await this.keyvalManager.set('userAvatar', url, 'avatarImage');
    await this.avatarImage.loadUserAvatarUrl();
  }

  public async unsetBotImg() {
    await this.keyvalManager.set('botAvatar', '', 'avatarImage');
    await this.avatarImage.loadBotAvatarUrl();
  }

  public async unsetUserImg() {
    await this.keyvalManager.set('userAvatar', '', 'avatarImage');
    await this.avatarImage.loadUserAvatarUrl();
  }
}